import React from 'react';

/**
 * Wooden rail + blue felt recessed play surface.
 * Children are absolutely positioned relative to the felt/shell.
 */
export default function TableShell({ children, chrome, seatCount = 0 }) {
  return (
    <div className="cv2-stage">
      <div className="cv2-table-shell" role="region" aria-label="Gutz table">
        <div className="cv2-table-rail" aria-hidden="true" />
        <div
          className="cv2-table-felt"
          data-seat-count={seatCount > 0 ? String(seatCount) : undefined}
        >
          {children}
        </div>
        {chrome}
      </div>
    </div>
  );
}
